import styled from "styled-components";

export const Container = styled.div`
  background-color: #f4efe8;
  min-height: 100vh;
  max-width: 100%;
  overflow-x: hidden;
`;

export const LocationSelect = styled.select`
  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #111111;
  background: #ffffff;
  border: 1.5px solid #d4ccc4;
  border-radius: 10px;
  padding: 8px 36px 8px 14px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  min-width: 200px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23555' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  transition: border-color 0.15s;

  &:focus { border-color: #111111; }

  @media (max-width: 768px) {
    min-width: 160px;
    font-size: 13px;
  }
`;
